import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/** Signals prerender script that React content is ready for the current route. */
export function PrerenderSignal() {
  const { loading } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    delete document.documentElement.dataset.prerenderReady;
    delete document.documentElement.dataset.prerenderPath;
  }, [pathname]);

  useEffect(() => {
    if (loading) return;
    const mark = () => {
      document.documentElement.dataset.prerenderReady = '1';
      document.documentElement.dataset.prerenderPath = pathname;
      document.dispatchEvent(new Event('prerender-ready'));
    };
    requestAnimationFrame(() => {
      requestAnimationFrame(mark);
    });
  }, [loading, pathname]);

  return null;
}
